import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material';
import React from 'react';
import { FaRegCopy } from 'react-icons/fa6';

import { PeopleCardViewProps } from './types';

export const PeopleCardView = ({ data, rows }: PeopleCardViewProps) => {
  const theme = useTheme();

  const CopyToClipboard = (card: any) => {
    const cardContent = Object.entries(card)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
    navigator.clipboard
      .writeText(cardContent)
      .then(() => {})
      .catch((err) => {
        console.error('Failed to copy card content: ', err);
      });
  };
  return (
    <Box
      sx={{
        padding: '15px',
        maxWidth: '100%',
        boxSizing: 'border-box',
        paddingLeft: '40px',
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '20px' }}
      >
        {data.title}
      </Typography>

      <Box
        sx={{ display: 'grid', gridTemplateColumns: `repeat(${rows}, 1fr)`, gap: '16px' }}
      >
        {data.cards.map((card, index) => (
          <Card
            key={index}
            sx={{
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              padding: '14px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  color:
                    card.status && card.status.includes('DONE')
                      ? '#2D864B'
                      : theme.palette.primary.main,
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                {card.status}
              </Typography>
              <Tooltip title={'Click to copy'}>
                <IconButton onClick={() => CopyToClipboard(card)}>
                  <FaRegCopy
                    color={
                      card.status && card.status.includes('DONE')
                        ? '#2D864B'
                        : theme.palette.primary.main
                    }
                  />
                </IconButton>
              </Tooltip>
            </Box>
            <CardContent>
              {Object.entries(card)
                .filter(([key]) => key !== 'status')
                .map(([key, value]) => (
                  <Box key={key} sx={{ marginBottom: '16px' }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        color: '#666',
                        marginBottom: '8px',
                      }}
                    >
                      {key}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', textTransform: 'capitalize' }}>
                      {value}
                    </Typography>
                  </Box>
                ))}
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};
